import type * as React from 'react';
import { post } from '@Domain/Api';
import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';
import invitationResent, {
	type InvitationResentAction,
} from '@Application/Users/Users/Actions/invitationResent';
import invitationResendFailed, {
	type InvitationResendFailedAction,
} from '@Application/Users/Users/Actions/invitationResendFailed';
import type ResendInvitation from '@Application/Users/Users/Commands/ResendInvitation';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = InvitationResentAction | InvitationResendFailedAction;

export default (command: ResendInvitation) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<UserPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/users/${command.userId}/invitation`,
				{},
			);

			const action = invitationResent(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = invitationResendFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
